export const stack = (state) => state.stack;
